<template>
  <div class="campus-card">
    <div class="card-header" :style="{ background: headerGradient }">
      <div class="header-icon">
        <span class="material-symbols-outlined">{{ campus.icon }}</span>
      </div>
      <h3 class="header-title">{{ campus.name }}</h3>
    </div>

    <div class="card-body">
      <p class="campus-description">{{ campus.description }}</p>
      
      <div class="campus-action-bottom">
        <button class="action-button" :style="{ background: campus.color }" @click="openMap">
          <span class="material-symbols-outlined">directions</span>
          <span class="action-text">Get Directions</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampusMapCard',
  props: {
    campus: {
      type: Object,
      required: true
    }
  },
  computed: {
    headerGradient() {
      const baseColor = this.campus.color || '#0068A2';
      // Create a lighter version for gradient
      return `linear-gradient(135deg, ${baseColor} 0%, ${this.lightenColor(baseColor, 20)} 100%)`;
    }
  },
  methods: {
    openMap() {
      window.open(this.campus.mapLink, '_blank');
    },
    lightenColor(color, percent) {
      // Simple color lightening (works for hex colors)
      const num = parseInt(color.replace('#', ''), 16);
      const amt = Math.round(2.55 * percent);
      const R = (num >> 16) + amt;
      const G = (num >> 8 & 0x00FF) + amt;
      const B = (num & 0x0000FF) + amt;
      return '#' + (
        0x1000000 +
        (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
        (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
        (B < 255 ? B < 1 ? 0 : B : 255)
      ).toString(16).slice(1);
    }
  }
};
</script>

<style scoped>
.campus-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
}

.campus-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
}

/* Card Header */
.card-header {
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  color: white;
}

.header-icon {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  flex-shrink: 0;
}

.header-icon .material-symbols-outlined {
  font-size: 28px;
  color: white;
}

.header-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
}

/* Card Body */
.card-body {
  padding: 1rem 1.5rem 1.5rem 1.5rem;
}

.campus-description {
  font-size: 0.9375rem;
  color: #6b7280;
  margin: 0 0 1.25rem 0;
  line-height: 1.5;
}

.campus-action-bottom {
  display: flex;
  justify-content: flex-end;
}

.action-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  border-radius: 12px;
  color: white;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  border: none;
  outline: none;
}

.action-button:hover {
  transform: translateX(4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.action-button .material-symbols-outlined {
  font-size: 20px;
}

.action-text {
  white-space: nowrap;
}

/* Responsive */
@media (max-width: 640px) {
  .card-header {
    padding: 1.25rem;
  }

  .header-icon {
    width: 40px;
    height: 40px;
  }

  .header-icon .material-symbols-outlined {
    font-size: 24px;
  }

  .header-title {
    font-size: 1.125rem;
  }

  .card-body {
    padding: 0.75rem 1rem 1rem 1rem;
  }

  .campus-description {
    font-size: 0.875rem;
    margin-bottom: 1rem;
  }

  .action-button {
    padding: 0.625rem 1rem;
  }
}
</style>
